import { render, staticRenderFns } from "./ModalAddressDetail.vue?vue&type=template&id=00545601&scoped=true&"
import script from "./ModalAddressDetail.vue?vue&type=script&lang=js&"
export * from "./ModalAddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddressDetail.vue?vue&type=style&index=0&id=00545601&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00545601",
  null
  
)

export default component.exports